import { Box, Typography } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** A single Q&A card of the FAQ accordion; the chevron rotates 180° and the answer expands with a height animation */
var IntroFaqItem = function IntroFaqItem(props) {
  var item = props.item,
      expanded = props.expanded,
      onToggle = props.onToggle;
  /**
   * methods
   */

  var toggleAction = function toggleAction() {
    onToggle();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "cursor-pointer rounded-xl bg-white px-6 py-6 shadow-[0_12px_40px_-28px_rgba(0,109,176,0.35)] transition-shadow duration-300 hover:shadow-[0_16px_48px_-28px_rgba(0,109,176,0.5)] md:px-8",
    onClick: toggleAction,
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center justify-between space-x-4",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-base font-black text-[#202020] md:text-lg",
        children: item.question
      }), /*#__PURE__*/_jsx(motion.div, {
        className: "flex-shrink-0",
        animate: {
          rotate: expanded ? 180 : 0
        },
        transition: {
          duration: 0.3
        },
        children: /*#__PURE__*/_jsx(Box, {
          component: "svg",
          viewBox: "0 0 24 24",
          className: "h-5 w-5 fill-[#202020]",
          children: /*#__PURE__*/_jsx("path", {
            d: "M12 15.5 4.5 8 6 6.5l6 6 6-6L19.5 8 12 15.5z"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(AnimatePresence, {
      initial: false,
      children: expanded && /*#__PURE__*/_jsx(motion.div, {
        className: "overflow-hidden",
        initial: {
          height: 0,
          opacity: 0
        },
        animate: {
          height: 'auto',
          opacity: 1
        },
        exit: {
          height: 0,
          opacity: 0
        },
        transition: {
          duration: 0.35,
          ease: [0.22, 1, 0.36, 1]
        },
        children: /*#__PURE__*/_jsx(Typography, {
          className: "pt-4 text-sm font-medium leading-7 text-[#202020] md:text-lg",
          children: item.answer
        })
      })
    })]
  });
};

export default IntroFaqItem;